const getDataField = (column) => (typeof column === 'string' ? column : column?.dataField);

const isDataColumn = (column) => {
    const dataField = getDataField(column);
    return Boolean(dataField && !column?.isSystemCol && !column?.command && !column?.buttons);
};

const getPriority = (dataField) => {
    const field = String(dataField || '').toLowerCase();
    if (['name', 'title', 'display_name', 'description_short'].includes(field)) return 0;
    if (/(^|_)(name|title)$/.test(field)) return 1;
    if (/(^|_)(code|sku|barcode)$/.test(field)) return 2;
    if (/(name|title)/.test(field)) return 3;
    if (/(code|sku|barcode)/.test(field)) return 4;
    if (/(description|note|error|attachment|image|html|json)/.test(field)) return 9;
    return 5;
};

const normalizeColumn = (column, sourceColumns) => {
    const dataField = getDataField(column);
    if (!dataField) return null;
    const source = sourceColumns.find((item) => item?.dataField === dataField) || {};
    const overrides = typeof column === 'object' ? column : {};
    return {
        ...source,
        ...overrides,
        dataField,
        caption: overrides.caption !== undefined ? overrides.caption : source.caption
    };
};

export const resolveBatchConfirmationColumns = (action, columns, options = {}) => {
    const sourceColumns = (columns instanceof Array ? columns : []).filter(isDataColumn);
    const configuredColumns = action?.confirmationColumns || action?.confirmColumns || options.confirmationColumns;

    if (configuredColumns instanceof Array && configuredColumns.length > 0) {
        return configuredColumns.map((column) => normalizeColumn(column, sourceColumns)).filter(Boolean);
    }

    const maxColumns = Math.max(1, Number(options.maxColumns) || 3);
    const visibleColumns = sourceColumns.filter((column) => column.visible !== false);
    const candidates = visibleColumns.length > 0 ? visibleColumns : sourceColumns;

    return candidates
        .map((column, index) => ({ column, index, priority: getPriority(column.dataField) }))
        .sort((left, right) => left.priority - right.priority || left.index - right.index)
        .slice(0, maxColumns)
        .map((item) => item.column);
};

export default resolveBatchConfirmationColumns;
